module.exports = "../images/kayaking.jpg?v=32ca936";